import { globs } from "../../../../services/globs";

const key = "allow-alias-management";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);

	const allowAliases = { Effect: "Allow", Path: globs.entityTypes.byType("DEALER").aliases.byCode("*").read };
	role.Actions.push(allowAliases);

};

export const allowAliasManagement = [key, applicable, modify];